export const formatNumber = (value, maxDecimals = 2, locale = "pt-BR") => {
    if (value === null || value === undefined || isNaN(value) || value === "")
        return "-"
    return new Intl.NumberFormat(locale, {
        maximumFractionDigits: maxDecimals,
    }).format(value)
}
